import { render } from "./Indexslides.vue?vue&type=template&id=20aa37d0&scoped=true"
import script from "./Indexslides.vue?vue&type=script&lang=js"
export * from "./Indexslides.vue?vue&type=script&lang=js"

import "./Indexslides.vue?vue&type=style&index=0&id=20aa37d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aa37d0"],['__file',"src/js/components/Indexslides.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20aa37d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20aa37d0', __exports__)) {
    api.reload('20aa37d0', __exports__)
  }
  
  module.hot.accept("./Indexslides.vue?vue&type=template&id=20aa37d0&scoped=true", () => {
    api.rerender('20aa37d0', render)
  })

}


export default __exports__